(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  customElements.whenDefined('x-modal').then(() => {
    if (customElements.get('giavor-newsletter-popup')) return;
    const filledKey = 'theme:popup-filled';
    const seenKey = 'giavor:newsletter:last-seen';
    const pendingKey = 'giavor:newsletter:pending';
    const store = {
      get(key, session = false) {
        try { return (session ? sessionStorage : localStorage).getItem(key); } catch { return null; }
      },
      set(key, value, session = false) {
        try { (session ? sessionStorage : localStorage).setItem(key, value); return true; } catch { return false; }
      },
      remove(key) {
        try { sessionStorage.removeItem(key); } catch {}
      }
    };
    if (document.querySelector('[data-giavor-newsletter-success]')) store.set(filledKey, 'true');

    class GiavorNewsletterPopup extends customElements.get('x-modal') {
      connectedCallback() {
        super.connectedCallback();
        const signal = this.abortController.signal;
        this.intro = this.querySelector('[data-newsletter-intro]');
        this.formStep = this.querySelector('[data-newsletter-form]');
        this.querySelector('[data-newsletter-accept]')?.addEventListener('click', () => this.showForm(true), { signal });
        this.querySelector('form')?.addEventListener('submit', () => {
          store.set(pendingKey, JSON.stringify({ id: this.dataset.formId, time: Date.now() }), true);
        }, { signal });
        this.addEventListener('dialog:before-show', () => {
          if (!this.hasAttribute('data-design-mode')) store.set(seenKey, String(Date.now()));
        }, { signal });
        this.addEventListener('dialog:before-hide', () => {
          if (!this.hasAttribute('data-design-mode')) store.set(seenKey, String(Date.now()));
        }, { signal });
        if (this.started) return;
        this.started = true;
        let pending;
        try { pending = JSON.parse(store.get(pendingKey, true) || 'null'); } catch {}
        const feedback = this.querySelector('[data-giavor-newsletter-success], [role="alert"]');
        if (pending?.id === this.dataset.formId && Date.now() - pending.time < 1800000 && feedback) {
          store.remove(pendingKey);
          this.showForm(false);
          this.show();
          return;
        }
        if (this.hasAttribute('data-design-mode') || !this.canAppear()) return;
        const delay = Math.max(20, Number(this.getAttribute('apparition-delay')) || 25) * 1000;
        this.timer = setTimeout(() => {
          if (!this.isConnected || !this.canAppear() || document.visibilityState !== 'visible') return;
          if (document.documentElement.classList.contains('lock') || document.querySelector('[role="dialog"][open], dialog[open], shopify-chat[open]')) return;
          if (document.activeElement?.matches('input, textarea, select, iframe, [contenteditable="true"]')) return;
          this.show();
        }, delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        super.disconnectedCallback();
      }
      get initialFocus() {
        return () => this.focusTarget;
      }
      get focusTarget() {
        return this.formStep?.hidden
          ? this.querySelector('[data-newsletter-accept]')
          : this.querySelector('input[type="email"], [data-giavor-newsletter-success]');
      }
      canAppear() {
        if (store.get(filledKey) === 'true') return false;
        const lastSeen = Number(store.get(seenKey));
        const days = Math.max(7, Number(this.getAttribute('frequency-days')) || 7);
        if (lastSeen && Date.now() - lastSeen < days * 86400000) return false;
        if (!lastSeen && store.get('theme:popup-appeared') === 'true') {
          store.set(seenKey, String(Date.now()));
          return false;
        }
        return store.set('giavor:newsletter:storage-check', '1');
      }
      showForm(moveFocus) {
        this.intro.hidden = true;
        this.formStep.hidden = false;
        if (moveFocus) this.focusTarget?.focus({ preventScroll: true });
      }
    }
    customElements.define('giavor-newsletter-popup', GiavorNewsletterPopup);
  });

  } catch(e) { console.error(e); }
})();
})();
